import React from "react";

export default function Pagination({ page, totalPages, onChange }) {
    if (totalPages <= 1) return null;

    const pages = [];
    const push = (v) => pages.push(v);

    // แบบในรูป: 1 2 3 4 5 ... 10
    const max = totalPages;
    const showLeft = [1, 2, 3, 4, 5].filter((x) => x <= max);
    showLeft.forEach(push);
    if (max > 6) push("...");
    if (max > 5) push(max);

    return (
        <div className="flex items-center gap-2">
            {pages.map((p, i) =>
                p === "..." ? (
                    <span key={`dot-${i}`} className="px-2 text-slate-400">…</span>
                ) : (
                    <button
                        key={p}
                        onClick={() => onChange?.(p)}
                        className={`w-8 h-8 rounded-lg text-sm font-semibold border-2 transition ${p === page
                                ? "bg-[#047DED] text-white border-[#047DED]"
                                : "bg-white text-slate-700 border-black/20 hover:bg-slate-50"
                            }`}
                    >
                        {p}
                    </button>
                )
            )}
        </div>
    );
}
